import React, { useContext, useEffect, useMemo, useRef } from 'react'
import { Button, Menu } from 'semantic-ui-react'
import _ from 'lodash'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { gEnums } from 'global/enums/globalEnums'
import { setStyleAndClass } from 'global/styles/formatting'
import { uniqueKey } from 'global/common/keys'
import { formatItem, formatTypes } from 'global/common/dateFormatting'
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles'

export const _swiperMenuTypes = {
  menu: 'menu',
  buttons: 'buttons'
}

export function SwiperMenu({
  swipeContentType,
  menuItems,
  extraButtons,
  groupDataProps,
  swiperMenuType,
  handleIndexChange,
  activeIndex,
}) {
  /* ------------------------------------------------------------------ */
  /* context + styles */
  /* ------------------------------------------------------------------ */

  const styleFns = useStyles()

  const tabStyles = useMemo(() => ({
    tabsSnC: styleFns.setStyleAndClass({ item: gEnums.projectStyles.tabs }),
    tabsSnC_active: styleFns.setStyleAndClass({ item: gEnums.projectStyles.tabs, forActive: true }),
    tabsSnC_line: styleFns.setStyleAndClass({ item: gEnums.projectStyles.tabs, forLine: true }),
  }), [])


  // const tabStyles = useMemo(() => ({
  //   tabsSnC: setStyleAndClass(aps_global, gEnums.projectStyles.tabs),
  //   tabsSnC_active: setStyleAndClass(
  //     aps_global,
  //     gEnums.projectStyles.tabs,
  //     null,
  //     null,
  //     true
  //   ),
  //   tabsSnC_line: setStyleAndClass(
  //     aps_global,
  //     gEnums.projectStyles.tabs,
  //     null,
  //     null,
  //     false,
  //     true
  //   ),
  // }), [aps_global])

  const menuItems_sorted = useMemo(() => {
    const sorted = _.sortBy(menuItems, 'position')
    return sorted
  }, [menuItems])

  const { tabsSnC, tabsSnC_active, tabsSnC_line } = tabStyles

  const activeSnC = {
    className: 'swipe-tab',
    style: { ...tabsSnC_line.style, ...tabsSnC_active.style },
  }

  const menuItemStyle = isActive => (isActive ? activeSnC : tabsSnC)

  /* ------------------------------------------------------------------ */
  /* refs + effects */
  /* ------------------------------------------------------------------ */

  const outerRef = useRef(null)

  useEffect(() => {
    if (!outerRef.current) return

    const container = outerRef.current
    const innerWrapper = container.firstElementChild
    const button = innerWrapper?.children?.[activeIndex]

    if (!button) return

    const containerWidth = container.offsetWidth
    const buttonLeft = button.offsetLeft
    const buttonWidth = button.offsetWidth

    const scrollPosition =
      buttonLeft - containerWidth / 2 + buttonWidth / 2

    container.scrollTo({ left: scrollPosition, behavior: 'smooth' })
  }, [activeIndex])

  /* ------------------------------------------------------------------ */
  /* derived items */
  /* ------------------------------------------------------------------ */

  const items = useMemo(() => {
    if (_.isEmpty(menuItems_sorted)) { return [] }
    return _.map(menuItems_sorted, (item, idx) => {
      const { groupByProp } = item ?? {}
      let caption = item.caption ?? item.display?.caption
      if (groupByProp === 'startDate') {
        caption = formatItem(formatTypes.dateDayMonth, caption)
      }
      return {
        key: item.key ?? idx,
        caption: caption || _.startCase(item?.key) || _.startCase(idx),
      }
    })
  }, [swipeContentType, menuItems_sorted])

  if (_.isEmpty(items)) return null

  // const buttons = useMemo(() => {
  //   if (_.isEmpty(items)) { return [] }
  //   const _buttons = _.map(items, (item, idx) => (
  //     <Button
  //       key={uniqueKey('sw', 'btn', idx)}
  //       color={activeIndex === idx ? 'blue' : null}
  //       className={activeIndex === idx ? 'btn-sel' : null}
  //       onClick={() => handleIndexChange(idx)}
  //     >
  //       {item.caption}
  //     </Button>
  //   ));
  //   return _buttons
  // }, [items])

  // const extras = useMemo(() => {
  //   if (_.isEmpty(extraButtons)) { return [] }
  //   const _extras = _.map(extraButtons, (eb) => (
  //     <Button
  //       key={uniqueKey("sw", "btn", "s", eb.icon)}
  //       icon
  //       inverted={eb.inverted}
  //       onClick={() => handleIndexChange(eb)}
  //     >
  //       <Icon name={eb.icon} color={eb.color} />
  //     </Button>
  //   ));
  //   return _extras
  // }, [extraButtons])

  /* ------------------------------------------------------------------ */
  /* render helpers */
  /* ------------------------------------------------------------------ */

  const buttons = () => {
    return _.map(items, (item, idx) => {
      const _key = item?.key || idx
      return <Button
        key={uniqueKey('sw', 'btn', _key)}
        color={activeIndex === idx ? 'blue' : null}
        className={activeIndex === idx ? 'btn-sel' : null}
        onClick={() => handleIndexChange(idx)}
      >
        {item.caption}
      </Button>
    })
  }

  const menu_items = () => {
    return _.map(items, (item, idx) => {
      const _key = item?.key || idx
      return <Menu.Item
        {...menuItemStyle(activeIndex === idx)}
        key={item.key}
        active={activeIndex === idx}
        onClick={() => handleIndexChange(idx)}
      >
        {item.caption}
      </Menu.Item>
    })
  }

  const renderButtons = () => (
    <div ref={outerRef} className='ms-button-group swr' style={tabStyles.tabsSnC.style}>
      <Button.Group
        className='swipe-tab-container swr'
        style={{ display: 'inline-flex' }}
        size='mini'
      >
        {buttons()}
        {/* {items.map((item, idx) => (
          <Button
            key={uniqueKey('sw', 'btn', idx)}
            color={activeIndex === idx ? 'blue' : null}
            className={activeIndex === idx ? 'btn-sel' : null}
            onClick={() => handleIndexChange(idx)}
          >
            {item.caption}
          </Button>
        ))} */}
      </Button.Group>
    </div>
  )

  const renderMenu = () => (
    <Menu pointing secondary className='swipe-tab-container' {...tabsSnC}>
      {menu_items()}
      {/* {items.map((item, idx) => (
        <Menu.Item
          {...menuItemStyle(activeIndex === idx)}
          key={item.key}
          active={activeIndex === idx}
          onClick={() => handleIndexChange(idx)}
        >
          {item.caption}
        </Menu.Item>
      ))} */}
    </Menu>
  )

  /* ------------------------------------------------------------------ */
  /* final render */
  /* ------------------------------------------------------------------ */

  return swiperMenuType === _swiperMenuTypes.buttons
    ? renderButtons()
    : renderMenu()
}
